import React, { Component } from 'react';
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';

const URL = Constants.URL.root+'/wp-json/wp/v2/wrapping?_embed';

class Wrapping extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoaded: false,
			error: null,
			runAPI: false
		}
	}

	fetchWrapping = () => {
		this.setState({ runAPI: true });
		var self = this;
		fetch(URL)
		.then(response => {
			if (!response.ok) {
				throw Error('Network request failed.')
			}
			return response;
		})
		.then(data => data.json())
		.then(data => {
			//console.log(data);
			self.dispatchWrappingData(data);
			self.selectWrapInitial(data[0]);
			self.setState({ isLoaded: true });
		}, (ex) => {
			self.setState({ error: ex.message });
		})
	}

	dispatchWrappingData(WrapData) {
		const data = WrapData;
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				wrapping: data
			}
		})
	}

	selectWrapInitial = (wrap) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedWrapping: wrap
			}
		})
	}

	selectWrapping = (wrap) => {
		const wrapTitle = wrap.getIn(['title', 'rendered'])
		let wrapEdge = 'image-wrap'
		if (wrapTitle === 'Mirrored')
			wrapEdge = 'mirror-wrap'
		else if (wrapTitle === 'White')
			wrapEdge = 'white'
		else if (wrapTitle === 'Black')
			wrapEdge = 'black'

		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedWrapping: wrap,
				wrapEdge: wrapEdge
			}
		})
	}

	componentDidMount() {
		this.fetchWrapping();
	}

	render() {
		const { isLoaded, error } = this.state;
		const { selectedWrapping, wrapping } = this.props;
		if (error) {
			return <div className="alert alert-danger">{error}</div>;
		} else {
			return (
				<div className="frm_mn_box">
					{isLoaded ?
						<div className="row">
							<div className="col-md-10 col-sm-12">
								<div className="row">
									{wrapping.map( (wrap) =>
										<div className="col-sm-4" key={wrap.get('id')} onClick={this.selectWrapping.bind(this, wrap)} style={{ cursor: 'pointer' }}>
											<strong style={{ marginBottom: 10, display: 'block', color: '#000'}}>{wrap.getIn(['title', 'rendered'])}</strong>
											<img className={selectedWrapping.get('id') === wrap.get('id') ? "selectedImageFrameNew" : ''} src={wrap.getIn(['_embedded', 'wp:featuredmedia', 0, 'media_details', 'sizes', 'medium', 'source_url'])} alt={wrap.getIn(['title', 'rendered'])} />
										</div>
									)}
								</div>
							</div>
						</div>
					: <Loader/>}
				</div>
			);
		}
	}
}

export default Wrapping;